// aiuto/testo.ts — il piccolo formato dei testi d'aiuto (lavoro G): paragrafi separati da una riga vuota, elenchi con
// righe «- », **grassetto**, [collegamenti](/percorso) solo verso le pagine del sito, segnaposto {{nome}}.
// Qui solo funzioni pure (le prova aiuto.test.ts); il disegno con React è in Aiuto.tsx.

export type Pezzo = { tipo: "testo"; testo: string } | { tipo: "grassetto"; testo: string } | { tipo: "link"; testo: string; percorso: string };
export type Blocco = { tipo: "paragrafo"; righe: Pezzo[][] } | { tipo: "elenco"; voci: Pezzo[][] };

/** Sostituisce i segnaposto con i valori; quelli senza valore restano visibili così come sono (meglio che sparire). */
export function riempi(s: string, valori: Readonly<Record<string, string | number>>): string {
  return s.replace(/\{\{\s*([a-zA-Z_]+)\s*\}\}/g, (tutto, k: string) => (k in valori ? String(valori[k]) : tutto));
}

/** Grassetto e collegamenti di una riga. */
export function pezzi(riga: string, collegamenti: readonly string[]): Pezzo[] {
  const out: Pezzo[] = [];
  const re = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;
  let ultimo = 0;
  for (const m of riga.matchAll(re)) {
    if (m.index! > ultimo) out.push({ tipo: "testo", testo: riga.slice(ultimo, m.index) });
    if (m[1] !== undefined) out.push({ tipo: "grassetto", testo: m[1] });
    else if (collegamenti.includes(m[3]!)) out.push({ tipo: "link", testo: m[2]!, percorso: m[3]! });
    else out.push({ tipo: "testo", testo: m[2]! }); // collegamento non ammesso: resta il testo
    ultimo = m.index! + m[0].length;
  }
  if (ultimo < riga.length) out.push({ tipo: "testo", testo: riga.slice(ultimo) });
  return out;
}

export function blocchi(s: string, collegamenti: readonly string[]): Blocco[] {
  const out: Blocco[] = [];
  for (const parte of s.split(/\n\s*\n/)) {
    let paragrafo: Pezzo[][] = [];
    let elenco: Pezzo[][] = [];
    const chiudiParagrafo = () => {
      if (paragrafo.length) out.push({ tipo: "paragrafo", righe: paragrafo });
      paragrafo = [];
    };
    const chiudiElenco = () => {
      if (elenco.length) out.push({ tipo: "elenco", voci: elenco });
      elenco = [];
    };
    for (const riga of parte.split("\n")) {
      const r = riga.trim();
      if (!r) continue;
      if (/^[-•]\s+/.test(r)) {
        chiudiParagrafo();
        elenco.push(pezzi(r.replace(/^[-•]\s+/, ""), collegamenti));
      } else {
        chiudiElenco();
        paragrafo.push(pezzi(r, collegamenti));
      }
    }
    chiudiParagrafo();
    chiudiElenco();
  }
  return out;
}

/** Testo semplice (per la ricerca e per copiare i modelli di risposta): senza ** e con i collegamenti come testo. */
export function testoSemplice(s: string): string {
  return s.replace(/\*\*([^*]+)\*\*/g, "$1").replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");
}
